<template>
  <div>
    <div class="right" style="padding-bottom: 2vh" v-if="!disabled">
        <ButtonField text="添加" primary @click="add"/>
    </div>
      <Tablelist
              :showCheckbox="false"
              :list="list"
              :columns="tableColumns"
      >
          <template #template-number="{ item }">
              <Money :money="item.number" />
          </template>
          <template #template-price="{ item }">
              <Money :money="item.price" />
          </template>
          <template #template-priceTotal="{ item }">
              <Money :money="item.priceTotal" />
          </template>
          <template v-slot:actions="{ item, index }">
              <a-space>
                  <a href="#" @click.prevent="edit(item, index)">编辑</a>
                  <a href="#" class="danger" @click.prevent="remove(index)">删除</a>
              </a-space>
          </template>
      </Tablelist>

    <Modal
            v-if="visible" v-model="visible"
             title="添加/编辑资产"
            :visible="visible"
            :showFooter="false"
            :overlayOpacity="0.5"
            contentWidth="50%"
            @update:visible="visible = $event"
    >
      <form :form="form">
          <div class="form-group-list">
              <div class="form-group">
                  <InputField
                          label="资产编号"
                          type="text"
                          id="code"
                          :modelValue="form.code"
                          placeholder="请输入资产编号"
                          disabled
                          @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                  />
              </div>
              <div class="form-group">
                  <InputField
                          label="资产名称"
                          type="text"
                          id="name"
                          :modelValue="form.name"
                          placeholder="请输入资产名称"
                          required
                          @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                  />
              </div>
          </div>
          <div class="form-group-list">
              <div class="form-group">
                  <InputField
                          label="品牌"
                          type="text"
                          id="name"
                          :modelValue="form.brand"
                          placeholder="请输入品牌"
                          @update:modelValue="(value) => handleModelValueUpdate('brand', value)"
                  />
              </div>
              <div class="form-group">
                  <InputField
                          label="规格型号"
                          type="text"
                          id="specification"
                          :modelValue="form.specification"
                          placeholder="请输入规格型号"
                          @update:modelValue="(value) => handleModelValueUpdate('specification', value)"
                  />
              </div>
          </div>
          <div class="form-group-list">
              <div class="form-group">
                  <InputField
                          label="单位"
                          type="text"
                          id="unit"
                          :modelValue="form.unit"
                          placeholder="请输入单位"
                          @update:modelValue="(value) => handleModelValueUpdate('unit', value)"
                  />
              </div>
              <div class="form-group">
                  <InputField
                          label="数量"
                          type="number"
                          id="number"
                          :modelValue="form.number"
                          placeholder="请输入数量"
                          required
                          @update:modelValue="(value) => handleModelValueUpdate('number', value)"
                  />
              </div>
          </div>
          <div class="form-group-list">
              <div class="form-group">
              <InputField
                      label="单价(元)"
                      type="number"
                      id="price"
                      :modelValue="form.price"
                      placeholder="请输入单价(元)"
                      required
                      @update:modelValue="(value) => handleModelValueUpdate('price', value)"
              />
              </div>
              <div class="form-group">
              </div>
          </div>
        <div class="right">
          <a-space>
              <ButtonField text="关闭" @click="cancel" secondary />
              <ButtonField text="提交" primary @click="handleSubmit"/>
          </a-space>
        </div>
      </form>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
          code:null,
          name:null,
          brand:null,
          specification:null,
          unit:null,
          number:null,
          price:null
      },
      visible: false,
      text: {},
      index: -1,
      tableColumns: [
          {key: 'index',title: '序号',field: 'index',infotype: 'index'},
          {key: 'code',title: '资产编号',field: 'code',infotype: 'text'},
          {key: 'name',title: '资产名称',field: 'name',infotype: 'text'},
          {key: 'brand',title: '品牌',field: 'brand',infotype: 'text'},
          {key: 'specification',title: '规格型号',field: 'specification',infotype: 'text'},
          {key: 'unit',title: '单位',field: 'unit',infotype: 'text'},
          {key: 'number',title: '数量',field: 'number',infotype: 'template'},
          {key: 'price',title: '单价(元)',field: 'price',infotype: 'template'},
          {key: 'priceTotal',title: '总价(元)',field: 'priceTotal',infotype: 'template'},
          {key: 'actions',title: '操作',infotype: 'template'}
      ]
    };
  },

  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    add() {
      this.visible = true;
    },
    edit(text, index) {
      this.text = text;
      this.index = index;
      this.form = this.text;
      this.visible = true;
    },
    remove(index) {
      this.list.splice(index, 1);
    },

    cancel() {
      this.visible = false;
      this.isSubmitting = false;
      this.text = {};
      this.index = -1;
    },

    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.form.name) {
            this.$message.error('资产名称不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.number) {
            this.$message.error('数量不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.price) {
            this.$message.error('单价(元)不能为空');
            this.isSubmitting = false;
            return;
        }
          if (this.index !== -1) {
            this.list.splice(this.index, 1, {
              ...this.text,
              ...this.form,
              priceTotal: this.form.number * this.form.price,
            });
          } else {
            this.list.push({
              ...this.form,
              priceTotal: this.form.number * this.form.price,
            });
          }

          this.cancel();
    },
  },
};
</script>
<style scoped>
.form-group-list{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 1rem 0;
}
.form-group{
    width: 100%;
    margin-right: 1rem;
}
</style>